import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api";

export default function OrganizationLiveToggle({ organizationId, name, live, canApprove = true }: {
  organizationId: string; name: string; live: boolean; canApprove?: boolean;
}) {
  const cache = useQueryClient();
  const update = useMutation({
    mutationFn: () => api.updateOrganizationLive(organizationId, !live),
    onSuccess: async () => {
      await Promise.all(["tech-ops-organizations", "tech-ops-organization", "tech-admin-audit"].map(key =>
        cache.invalidateQueries({ queryKey: [key] })));
    }
  });
  return <div>
    <button type="button" role="switch" aria-checked={live}
      aria-label={`Live access for ${name}`} disabled={!canApprove || update.isPending}
      className={`pa-settings-switch${live ? " active" : ""}`}
      onClick={() => update.mutate()}><span /></button>
    <small>{update.isPending ? "Saving…" : live ? "Live" : "Not live"}</small>
    {update.error ? <small className="pa-form-error" role="alert">{update.error.message}</small> : null}
  </div>;
}
